import React from "react";
import { LineChart, Line, ResponsiveContainer, YAxis } from "recharts";

export function Sparkline({ series = [], height = 40 }) {
  if (!series || series.length === 0) {
    return <div style={{ height }} className="flex items-center justify-center text-[10px] text-[#525252]">No data</div>;
  }
  const data = series.map((v, i) => ({ i, v }));
  const last = series[series.length - 1];
  const color = last >= 0 ? "#10B981" : "#EF4444";
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 2, bottom: 2, left: 0, right: 0 }}>
        <YAxis hide domain={["dataMin", "dataMax"]} />
        <Line type="monotone" dataKey="v" stroke={color} strokeWidth={1.75} dot={false} isAnimationActive={false} />
      </LineChart>
    </ResponsiveContainer>
  );
}
